import { defineMessages } from 'react-intl';

export const giftCardCheckoutPaymentMethodMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Payment method',
    description: 'Gift Card Checkout Form | Payment method | Section title',
  },
});
